import React from 'react';
import PropTypes from 'prop-types';
import activities from 'constants/activities';
import AgentFilter from './filters/AgentFilter';
import GroupFilter from './filters/GroupFilter';
import BillingsFilter from './filters/BillingsFilter';
import GroupTransactionsFilter from './filters/GroupTransactionsFilter';
import SettingFeaturesFilter from './filters/SettingFeaturesFilter';
import MicroloanRequestsFilter from './filters/MicroloanRequestsFilter';
import MemberFilter from './filters/MemberFilter';

const NON_DEFAULT_ACTIVITIES = [
  activities.ALL_SAVING_GROUPS,
  activities.GROUP_TRANSACTIONS,
  activities.SETTING_FEATURES,
  activities.BILLINGS,
  activities.MICROLOAN_REQUESTS,
];

const ActivityFilter = ({
  activity,
  category,
  form,
  handleChange,
  resourceId,
  group,
  types,
  typeName,
}) => {
  switch (activity) {
    case activities.AGENT:
      return (
        <AgentFilter
          handleChange={handleChange}
          organizationId={resourceId}
        />
      );
    case activities.GROUP:
      return (
        <GroupFilter
          category={category}
          handleChange={handleChange}
          resourceId={resourceId}
          form={form}
          group={group}
        />
      );
    case activities.BILLINGS:
      return (
        <BillingsFilter form={form} handleChange={handleChange} />
      );
    case activities.GROUP_TRANSACTIONS:
      return (
        <GroupTransactionsFilter
          form={form}
          handleChange={handleChange}
          typeName={typeName}
          types={types}
        />
      );
    case activities.SETTING_FEATURES:
      return (
        <SettingFeaturesFilter
          form={form}
          handleChange={handleChange}
        />
      );
    case activities.MICROLOAN_REQUESTS:
      return (
        <MicroloanRequestsFilter
          form={form}
          handleChange={handleChange}
        />
      );
    case activities.MEMBER:
      return (
        <MemberFilter
          handleChange={handleChange}
          typeName={typeName}
          group={group}
        />
      );
    default:
      return null;
  }
};

ActivityFilter.defaultProps = {
  activity: null,
  resourceId: null,
  group: {},
};

ActivityFilter.propTypes = {
  activity: PropTypes.string,
  category: PropTypes.string.isRequired,
  form: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
  resourceId: PropTypes.string,
  group: PropTypes.instanceOf(Object),
  types: PropTypes.instanceOf(Array).isRequired,
  typeName: PropTypes.string.isRequired,
};

export { NON_DEFAULT_ACTIVITIES };
export default ActivityFilter;
